export const FUND_LEVEL_PREFIX = "_fundLevel_";
export const addNumericValue = (current, addition) => {
    if (current === null && addition === null) {
        return null;
    }
    return (current ?? 0) + (addition ?? 0);
};
const navigateField = (row, fieldPath) => (fieldPath
    ? fieldPath.split(".").reduce((obj, key) => obj?.[key], row)
    : undefined);
export const getFieldValue = (row, fieldPath) => {
    const value = navigateField(row, fieldPath);
    if (value !== null && value !== undefined && typeof value === "object") {
        if ("amount" in value) {
            return value.amount;
        }
        if ("value" in value) {
            return value.value;
        }
    }
    return value;
};
export const getCurrency = (row, fieldPath) => navigateField(row, fieldPath)?.currency;
export const buildPivotGroupKey = (row, groupFields) => {
    const fundId = row.FundId ?? "";
    const investorId = groupFields.includes("InvestorId")
        ? row.InvestorId || row.InvestorName || ""
        : "";
    return { fundId, investorId, representation: `${fundId}|${investorId}` };
};
export const resolvePivotFields = (groupRows, fields) => {
    const result = {};
    fields.forEach((f) => {
        const row = groupRows.find((r) => r[f]);
        result[f] = row?.[f] ?? "";
    });
    return result;
};
export const resolveDisplayField = (resolved, displayField, groupRows) => {
    if (displayField !== "FundInvestorGroup") {
        return;
    }
    const fundRow = groupRows.find((r) => r.FundName);
    const investorRow = groupRows.find((r) => r.InvestorName);
    const fundName = fundRow?.FundName ?? "";
    const investorName = investorRow?.InvestorName ?? "";
    resolved.FundName = fundName;
    resolved.InvestorName = investorName;
    resolved[displayField] = investorName ? `${fundName} - ${investorName}` : fundName;
    resolved.FundNameGroup = fundName;
};
